import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/acreditacion-contratistas/")({
  beforeLoad: () => {
    throw redirect({ to: "/soluciones/acreditacion-contratistas/mine-pass" });
  },
});
